import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { observable, Observable, of, share, shareReplay, Subject, tap } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';
import { MenuItem } from 'primeng/api';
import { UserListLookup } from '../models/users/user-list-lookup';
import { UserAssignment } from '../models/user-assignment';
import { DelegationUsersResponse } from '../../delegate-slider/models/delegation-users-response';
import { CachedHttpService } from '../../../core/caching/cached-http.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  userList = [];
  userListObservable!: Observable<any>;
  menuItems: MenuItem[] = [];
  delegateUserListObservable?: Observable<DelegationUsersResponse>;

  constructor(private httpClient: HttpClient,
    private cachedHttpService: CachedHttpService
  ) {


  }

  // To do -- Need to specify User Type
  getUsers(): Observable<any> {
    return this.cachedHttpService.get<any>(ApiConstants.Users_Api);
  }

  refreshUsers(): Observable<any> {
    return this.cachedHttpService.refresh<any>(ApiConstants.Users_Api);
  }

  getUsersForDocument(scopes: number[]): Observable<UserListLookup[]> {
    const requestPayload = { scopes: scopes };
    return this.httpClient.get<UserListLookup[]>(ApiConstants.DocumentUsersList_Api, { params: requestPayload });
  }

  getUsersForCRI(scopes: number[]): Observable<UserListLookup[]> {
    const requestPayload = { scopes: scopes };
    return this.httpClient.get<UserListLookup[]>(ApiConstants.CRIUserList_Api, { params: requestPayload });
  }
  getUsersForHardCopy(scopes: number[]): Observable<UserListLookup[]> {
    const requestPayload = { scopes: scopes };
    return this.httpClient.get<UserListLookup[]>(ApiConstants.HardCopyUserList_Api, { params: requestPayload });
  }

  getUsersForDelegation(): Observable<DelegationUsersResponse> {
  if (this.delegateUserListObservable) {
    return this.delegateUserListObservable;
  }
  this.delegateUserListObservable = this.httpClient.get<DelegationUsersResponse>(ApiConstants.DelegationUserList_Api)
    .pipe(shareReplay(1));
  return this.delegateUserListObservable;
 }


  getUsersForCourse(scopes: number[]): Observable<UserListLookup[]> {
    const requestPayload = { scopes: scopes };
    return this.httpClient.get<UserListLookup[]>(ApiConstants.CourseUsersList_Api, { params: requestPayload });
  }

  getUsersForAssignment(scopes: number[], assignment: number): Observable<UserListLookup[]> {
    const requestPayload = { scopes: scopes, assignment: assignment };
    return this.httpClient.get<UserListLookup[]>(ApiConstants.AsignmentGroupUsersList_Api, { params: requestPayload });
  }

  getUsersForBulkUserScopeUpdate(): Observable<UserListLookup[]> {
    return this.httpClient.get<UserListLookup[]>(ApiConstants.BulkUserScopeUpdateUserList_Api);
  }

  linkedItemsSelected = new Subject<any[]>();
  public onLinkedItemsSelected(): Observable<any[]> {
    return this.linkedItemsSelected.asObservable();
  }

  validateUsers(usersList: UserAssignment[]): Observable<UserAssignment[]> {
    return this.httpClient.post<UserAssignment[]>(ApiConstants.ValidateUsersList_Api, usersList);
  }

  clearDelegateUserCache() {
    this.delegateUserListObservable = undefined;
  }
}
